import { createContext, useContext } from "react";

import type { DesignerNode } from "../../types/index.ts";

export type CssBindingsContextValues = {
  bindings: DesignerNode[];
  onAddBinding: (anchorEl: HTMLElement) => void;
  onEditBinding?: (bindingId: number, anchorEl: HTMLElement) => void;
  doesBindingExist: (name: string) => boolean;
};

// Create context with simple ID mapping
export const CssBindingsContext = createContext<CssBindingsContextValues>({
  bindings: [],
  onAddBinding: () => {},
  doesBindingExist: () => false,
});

export const useCssBindings = (): CssBindingsContextValues => {
  return useContext(CssBindingsContext);
};
